import { render, staticRenderFns } from "./UsersAdmin.vue?vue&type=template&id=067f55b2&scoped=true&"
import script from "./UsersAdmin.vue?vue&type=script&lang=ts&"
export * from "./UsersAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./UsersAdmin.vue?vue&type=style&index=0&id=067f55b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067f55b2",
  null
  
)

export default component.exports